<div class="amortization-plan-sidebar astral-sidebar-shell">
  <div class="astral-sidebar-content astral-stack-l">
    <h2 class="astral-sidebar-heading">{{ 'AMORTIZATION_PLAN.CREATE.TITLE' | translate }}</h2>
    <app-information-block
      [text]="(showContactSelection ? 'AMORTIZATION_PLAN.CREATE.SELECT_RECIPIENT_DESCRIPTION' : 'AMORTIZATION_PLAN.CREATE.DESCRIPTION') | translate"
    ></app-information-block>
    <div class="description d-none">
      {{ (showContactSelection ? 'AMORTIZATION_PLAN.CREATE.SELECT_RECIPIENT_DESCRIPTION' : 'AMORTIZATION_PLAN.CREATE.DESCRIPTION') | translate }}
    </div>

    @if (isLoading) {
      <div class="loading-text">{{ 'AMORTIZATION_PLAN.CREATE.LOADING' | translate }}</div>
    }

    @if (showContactSelection) {
      <form class="astral-stack-m" [formGroup]="form" (ngSubmit)="loadInvoicesForSelectedContact()">
        <section class="astral-section-surface astral-section-surface--compact">
          <div class="astral-layout-item">
            <app-autocomplete-remote [control]="form.controls['contactId']" [service]="contactFilterService"></app-autocomplete-remote>
          </div>
        </section>
        <div class="astral-form-actions">
          <astral-button variant="primary" type="submit" [disabled]="!selectedContactId || isLoading" labelKey="COMMON.CONTINUE"></astral-button>
          <astral-button variant="secondary" type="button" (click)="cancel()" [disabled]="isLoading" labelKey="CANCEL_BTN"></astral-button>
        </div>
      </form>
    }

    @if (preview && !isLoading) {
      <form class="astral-stack-l" [formGroup]="form" (ngSubmit)="submit()">
        <section class="astral-section-surface astral-section-surface--compact">
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
            <astral-input
              [label]="'AMORTIZATION_PLAN.CREATE.RECIPIENT' | translate"
              [value]="preview.debtorContactName || '-'"
              [readonly]="true"
            ></astral-input>
            <astral-input
              [label]="'AMORTIZATION_PLAN.CREATE.TOTAL_AMOUNT' | translate"
              [value]="selectedTotalAmount.amount | money: false : null : selectedTotalAmount.currencyCode"
              [readonly]="true"
            ></astral-input>
          </astral-layout-group>
        </section>
        <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
            <astral-select [control]="form.controls['articleId']" [itemsSource]="articleSelection"></astral-select>
            @if (selectedArticleId) {
              <astral-input
                [control]="form.controls['interestRate']"
                type="number"
                inputMode="decimal"
                [min]="0"
                [step]="0.01"
              ></astral-input>
            }
            <astral-select [control]="form.controls['leaseAgreementId']" [itemsSource]="leaseAgreementSelection"></astral-select>
            @if (selectedLeaseAgreement) {
              <astral-select [control]="form.controls['firstRentPeriodId']" [itemsSource]="firstRentPeriodSelection"></astral-select>
            } @else {
              <astral-date-picker [control]="form.controls['firstDueDate']"></astral-date-picker>
            }
            <astral-input
              [control]="form.controls['paymentCount']"
              type="number"
              inputMode="numeric"
              [min]="1"
              [step]="1"
            ></astral-input>
          </astral-layout-group>
          @if (showCustomDeliveryConfiguration) {
            <div class="section-title">{{ 'INVOICE.DELIVERY_METHOD' | translate }}</div>
            <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
              <app-invoice-delivery-method
                [control]="interestInvoiceDeliveryGroup.controls['deliveryMethod']"
                [company]="preview?.companyId"
                [payer]="preview?.debtorContactId"
              ></app-invoice-delivery-method>
              @if (showInterestInvoiceEmail) {
                <astral-input [control]="interestInvoiceDeliveryGroup.controls['email']" [type]="'email'" [inputMode]="'email'"></astral-input>
              }
              @if (showInterestInvoiceEInvoiceAddress) {
                <astral-input [control]="interestInvoiceDeliveryGroup.controls['eInvoiceAddress']"></astral-input>
              }
            </astral-layout-group>
            <div [class.d-none]="!showInterestInvoicePostalAddress">
              <div class="section-title">{{ 'INVOICE.PREVIEW.INVOICE_ADDRESS' | translate }}</div>
              <app-postal-address
                [group]="interestInvoiceDeliveryAddressGroup"
                [model]="interestInvoiceDeliveryAddressModel"
                [mandatory]="showInterestInvoicePostalAddress"
                [showName]="true"
                [nameLabel]="'ADDRESS_FORM.RECIPIENT_LABEL'"
                [title]="''"
                [countryColumnSpan]="2"
              ></app-postal-address>
            </div>
          }
          <astral-textarea [control]="form.controls['note']"></astral-textarea>
        </section>
        <div class="section">
          <div class="section-title">
            {{ 'AMORTIZATION_PLAN.CREATE.ELIGIBLE_INVOICES' | translate }} ({{ selectedEligibleInvoices.length }}/{{ preview.eligibleInvoices.length }})
          </div>
          @if (!preview.eligibleInvoices.length) {
            <div class="empty-state">{{ 'AMORTIZATION_PLAN.CREATE.NO_ELIGIBLE_INVOICES' | translate }}</div>
          }
          @if (preview.eligibleInvoices.length) {
            <div class="invoice-table">
              <div class="invoice-row invoice-row-header invoice-grid eligible-grid">
                <span>{{ 'AMORTIZATION_PLAN.CREATE.SELECT' | translate }}</span>
                <span>{{ 'INVOICE.INVOICE_NUMBER' | translate }}</span>
                <span>{{ 'INVOICE.DUE_DATE' | translate }}</span>
                <span>{{ 'INVOICE.REMAINING_AMOUNT' | translate }}</span>
                <span>{{ 'AMORTIZATION_PLAN.CREATE.INVOICE_STATUS' | translate }}</span>
              </div>
              @for (invoice of preview.eligibleInvoices; track invoice) {
                <div class="invoice-row invoice-grid eligible-grid">
                  <span class="checkbox-cell">
                    <astral-checkbox
                      variant="compact"
                      [showCaption]="false"
                      [checked]="invoice.selected"
                      (checkedChange)="toggleInvoiceSelection(invoice.invoiceId, $event)"
                    ></astral-checkbox>
                  </span>
                  <span>{{ invoice.invoiceNumber }}</span>
                  <span>{{ invoice.dueDate?.toLocaleDateString() }}</span>
                  <span>{{ invoice.unpaidAmount?.toString() }}</span>
                  <span class="invoice-status invoice-warning">
                    @if (invoice.hasWarning) {
                      {{ invoice.warningMessage }}
                    }
                  </span>
                </div>
              }
            </div>
          }
        </div>
        <div class="section">
          <div class="section-title">{{ 'AMORTIZATION_PLAN.CREATE.EXCLUDED_INVOICES' | translate }} ({{ preview.excludedInvoices.length }})</div>
          @if (!preview.excludedInvoices.length) {
            <div class="empty-state">{{ 'AMORTIZATION_PLAN.CREATE.NO_EXCLUDED_INVOICES' | translate }}</div>
          }
          @if (preview.excludedInvoices.length) {
            <div class="invoice-table">
              <div class="invoice-row invoice-row-header invoice-grid excluded-grid">
                <span>{{ 'INVOICE.INVOICE_NUMBER' | translate }}</span>
                <span>{{ 'INVOICE.DUE_DATE' | translate }}</span>
                <span>{{ 'INVOICE.REMAINING_AMOUNT' | translate }}</span>
                <span>{{ 'AMORTIZATION_PLAN.CREATE.INVOICE_STATUS' | translate }}</span>
              </div>
              @for (invoice of preview.excludedInvoices; track invoice) {
                <div class="invoice-row invoice-grid excluded-grid">
                  <span>{{ invoice.invoiceNumber }}</span>
                  <span>{{ invoice.dueDate?.toLocaleDateString() }}</span>
                  <span>{{ invoice.unpaidAmount?.toString() }}</span>
                  <span class="invoice-status invoice-excluded-message">{{ invoice.exclusionReason }}</span>
                </div>
              }
            </div>
          }
        </div>
        <div class="section">
          <div class="section-title">{{ 'AMORTIZATION_PLAN.CREATE.INSTALLMENTS' | translate }}</div>
          <div class="description">{{ 'AMORTIZATION_PLAN.CREATE.INSTALLMENTS_DESCRIPTION' | translate }}</div>
          @if (installmentPreview.length) {
            <div class="installment-preview">
              <div class="installment-preview-row installment-preview-header">
                <span>{{ 'AMORTIZATION_PLAN.CREATE.INSTALLMENT_DUE_DATE' | translate }}</span>
                <span>{{ 'AMORTIZATION_PLAN.CREATE.INSTALLMENT_AMOUNT' | translate }}</span>
              </div>
              @for (installment of installmentPreview; track installment) {
                <div class="installment-preview-row">
                  <span>{{ installment.dueDate?.toLocaleDateString() }}</span>
                  <span>{{ installment.amount | money: false : null : selectedTotalAmount?.currencyCode }}</span>
                </div>
              }
            </div>
          } @else {
            <div class="empty-state">{{ 'AMORTIZATION_PLAN.CREATE.INSTALLMENTS_PREVIEW_EMPTY' | translate }}</div>
          }
        </div>
        @if (!preview.canCreate || !selectedEligibleInvoices.length) {
          <div class="validation-message">
            {{ 'AMORTIZATION_PLAN.CREATE.NO_ELIGIBLE_INVOICES' | translate }}
          </div>
        }
        <div class="astral-form-actions">
          <astral-button variant="primary" type="submit" [disabled]="disableSubmit" labelKey="CREATE_BTN"></astral-button>
          <astral-button variant="secondary" type="button" (click)="cancel()" [disabled]="isSaving" labelKey="CANCEL_BTN"></astral-button>
        </div>
      </form>
    }
  </div>
</div>
